import { render, staticRenderFns } from "./ArapTransfer.vue?vue&type=template&id=408d0192&scoped=true"
import script from "./ArapTransfer.vue?vue&type=script&lang=js"
export * from "./ArapTransfer.vue?vue&type=script&lang=js"
import style0 from "./ArapTransfer.vue?vue&type=style&index=0&id=408d0192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d0192",
  null
  
)

export default component.exports